import { ApplicationRef, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  readonly theme = new BehaviorSubject<'light-theme' | 'dark-theme'>(
    'light-theme'
  );

  constructor(private ref: ApplicationRef) {
    // const darkModeOn =
    //   window.matchMedia &&
    //   window.matchMedia('(prefers-color-scheme: dark)').matches;
    //
    // if (darkModeOn) {
    //   this.theme.next('dark-theme');
    // }
    //
    // // watch for changes of the preference
    // window
    //   .matchMedia('(prefers-color-scheme: dark)')
    //   .addEventListener('change', (e) => {
    //     const turnOn = e.matches;
    //     this.theme.next(turnOn ? 'dark-theme' : 'light-theme');
    //     this.ref.tick();
    //   });
  }

  toggleTheme() {
    // this.theme.value === 'dark-theme' ? 'light-theme' : 'dark-theme'
    this.theme.next(
      'light-theme'
    );
  }
}
